module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGQ9Ik0yNDAtNDAwdjgwaC04MHEtMzMgMC01Ni41LTIzLjVUODAtNDAwdi00MDBxMC0zMyAyMy41LTU2LjVUMTYwLTg4MGg0MDBxMzMgMCA1Ni41IDIzLjVUNjQwLTgwMHY4MGgtODB2LTgwSDE2MHY0MDBoODBaTTQwMC04MHEtMzMgMC01Ni41LTIzLjVUMzIwLTE2MHYtNDAwcTAtMzMgMjMuNS01Ni41VDQwMC02NDBoNDAwcTMzIDAgNTYuNSAyMy41VDg4MC01NjB2NDAwcTAgMzMtMjMuNSA1Ni41VDgwMC04MEg0MDBabTAtODBoNDAwdi00MDBINDAwdjQwMFptMjAwLTIwMFoiICBmaWxsPSIjZmZmZmZmIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources-24px.svg
// module id = gIBV
// module chunks = 1